import {Input} from '@angular/core';
import {EntitySchemaService} from '@catcore/services/entity-schema.service';
import {EntitySchemaType} from '@catcore/utils/json-schema/entity-schema-to-json-schema';
import {LinkItem} from '@catui/types';

export abstract class DefaultEntityLanding<T> {

  selfTitle = 'Feature Fixed Routes';
  labels = {
    welcomeTitle: 'Welcome',
    availableItems: `Available ${this.selfTitle}`,
  };

  relatedEntities: LinkItem[];
  availableItems: LinkItem[];

  @Input() resourceId: string;
  @Input() resourceUri: string;
  @Input() parentResourceId: string;
  @Input() schema: any;

  @Input()
  get formData(): T {
    return this._formData;
  }

  set formData(formData: T) {
    this._formData = formData;
    this.onEntityReceived(this._formData);
  }

  protected _formData: any;

  constructor(private schemaService: EntitySchemaService) {
  }

  protected onEntityReceived(value: T) {
  }

  abstract getEntitySchemaTypeRef(): string;

  protected setSelfTitle(value: string): void {
    this.selfTitle = value;
    this.labels.availableItems = `Available ${this.selfTitle}`;
  }

  protected getRelatedEntityInfo() {
    const relatedEntities = this.schemaService
      .getRelatedEntitiesFor(EntitySchemaType[this.getEntitySchemaTypeRef()]);

    return relatedEntities;
  }

  protected getResourceId(): string {
    return this.resourceId;
  }

  protected getParentResourceId(): string {
    return this.parentResourceId;
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/core/shared/default-entity-landing.ts